var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDraftFile = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 28 34"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#0E141A",
  d: "M4.156 33.483a3.2 3.2 0 0 1-2.353-.978 3.2 3.2 0 0 1-.98-2.355V3.483q0-1.374.98-2.355A3.2 3.2 0 0 1 4.156.15h11.959a3.3 3.3 0 0 1 2.333.958l8.084 8.084q.457.459.708 1.061.25.606.25 1.272V30.15q0 1.375-.978 2.355a3.21 3.21 0 0 1-2.355.978zM17.49 11.817h6.667l-8.334-8.334v6.667q0 .708.48 1.187.479.48 1.187.48"
})));
export { SvgDraftFile as ReactComponent };
export default __webpack_public_path__ + "static/media/draft-file.9b89c475.svg";